import { mapGetters } from 'vuex'
import PazymaMap from './PazymaMap'

export default {
  mixins: [],
  computed: {
    ...mapGetters(['pazymaReadonly', 'pazymaBusena', 'pazymaTipas']),
    rengiamas() {
      return PazymaMap['pazymaBusena'].rengiamas.key
    },
    patvirtinti() {
      return PazymaMap['pazymaBusena'].patvirtinti.key
    },
    laukiaPatvirtinimo() {
      return PazymaMap['pazymaBusena'].laukia_patvirtinimo.key
    },
    laukiaApmokejimo() {
      return PazymaMap['pazymaBusena'].laukia_apmokejimo.key
    },
    perduotas() {
      return PazymaMap['pazymaBusena'].perduotas.key
    },
    grazintas() {
      return PazymaMap['pazymaBusena'].grazintas.key
    },
    nepatikslintas() {
      return PazymaMap['pazymaBusena'].nepatikslintas.key
    },
    iregistruotas() {
      return PazymaMap['pazymaBusena'].iregistruotas.key
    },
    atmestas() {
      return PazymaMap['pazymaBusena'].atmestas.key
    },
    isRengiamas() {
      return this.pazymaBusena === this.rengiamas
    },
    isPatvirtinti() {
      return this.pazymaBusena === this.patvirtinti
    },
    isLaukiaPatvirtinimo() {
      return this.pazymaBusena === this.laukiaPatvirtinimo
    },
    isLaukiaApmokejimo() {
      return this.pazymaBusena === this.laukiaApmokejimo
    },
    isPerduotas() {
      return this.pazymaBusena === this.perduotas
    },
    isGrazintas() {
      return this.pazymaBusena === this.grazintas
    },
    isNepatikslintas() {
      return this.pazymaBusena === this.nepatikslintas
    },
    isIregistruotas() {
      return this.pazymaBusena === this.iregistruotas
    },
    isAtmestas() {
      return this.pazymaBusena === this.atmestas
    },
  },
  methods: {
    //
  },
}
